import React from 'react';
import { TestimonialCarousel } from './components/ui/profile-card-testimonial-carousel';

export default function TestimonialCarouselDemo() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-6xl">
        <div className="mb-10 text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-gray-700">
            Customer Stories
          </p>
          <h1 className="mt-3 text-3xl md:text-5xl font-black text-gray-900">
            Profile Card Testimonial Carousel
          </h1>
          <p className="mt-4 text-sm md:text-base text-gray-700 max-w-2xl mx-auto">
            A shadcn-style testimonial carousel built for this React app with
            Indian sample names and portraits.
          </p>
        </div>
        <TestimonialCarousel />
      </div>
    </div>
  );
}
